import {SocketChannel, SocketEvent} from "ubcommunity-shared/src/Sockets/SocketProvider";

export const conversationChannel = new SocketChannel("conversation", {private: true});
export const typingEvent = new SocketEvent("client-typing", conversationChannel);
